import api from "./api";

export type VoucherType = "payment" | "receipt" | "journal";

export interface AccountVoucher {
  id: string;
  voucherNumber: string;
  voucherType: VoucherType | string;
  voucherDate: string;
  branchId: string;
  salesPointId: string | null;
  partyName: string | null;
  amount: number;
  paymentMethod: string | null;
  narration: string | null;
  createdAt: string;
}

export interface CreateVoucherData {
  voucherType: VoucherType;
  voucherDate: string;
  branchId: string;
  salesPointId: string;
  partyName?: string;
  amount: number;
  paymentMethod?: string;
  narration?: string;
}

export interface ListVouchersParams {
  startDate?: string;
  endDate?: string;
  branchId?: string;
  salesPointId?: string;
  voucherType?: VoucherType | string;
}

const voucherAPI = {
  list: async (params?: ListVouchersParams): Promise<AccountVoucher[]> => {
    const response = await api.get("/vouchers", { params });
    return response.data.data || [];
  },

  create: async (data: CreateVoucherData): Promise<AccountVoucher> => {
    const response = await api.post("/vouchers", data);
    return response.data.data;
  },
};

export default voucherAPI;
